<template>
    <div class="box-second">
        <p class="title-crumb">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>设备维保计划</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main">
            <div class="build-bar">
                <el-select v-model="detectionType" clearable placeholder="检测状态" @change="doFilter">
                    <el-option
                    v-for="item in types"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                    </el-option>
                </el-select>
                <!-- <el-button type="primary" @click="addRow()">添加</el-button> -->
            </div>
            <div class="main-table">
                <el-table :data="tableDataEnd" height="100%" style="width: 100%" :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column label="序号" type="index" width="100"></el-table-column>
                    <el-table-column label="设备名称">
                        <template slot-scope="scope">
                            <span>{{ scope.row.equipName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="型号规格">
                        <template slot-scope="scope">
                        <span>{{ scope.row.specifications }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="检测单位">
                        <template slot-scope="scope">
                        <span>{{ scope.row.testingUnit }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="检测报告及编号">
                         <template slot-scope="scope">
                            <span>{{ scope.row.testReportNumber }}</span>
                         </template>
                    </el-table-column>
                    <el-table-column label="检测日期">
                         <template slot-scope="scope">
                            <span>{{ scope.row.detectionDate }}</span>
                         </template>
                    </el-table-column>
                    <el-table-column label="检测有效期">
                         <template slot-scope="scope">
                            <span>{{ scope.row.detectionValidityDate }}</span>
                         </template>
                    </el-table-column>
                    <el-table-column label="到期天数">
                         <template slot-scope="scope">
                            <span>{{ scope.row.remaining }}</span>
                         </template>
                    </el-table-column>
                    <el-table-column label="状态">
                         <template slot-scope="scope">
                            <span v-if="scope.row.detectionType=='0'">--</span>
                            <span v-else-if="scope.row.detectionType=='1'" style="color:#F56C6C;">未处理</span>
                            <span v-else-if="scope.row.detectionType=='2'" style="color:#67C23A;">已处理</span>
                         </template>
                    </el-table-column>
                </el-table>
                <!-- 表单列表 -->
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 20, 50]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalItems"
                ></el-pagination>
            </div>
        </div>
        <!-- 新增窗口 -->
        <!-- <el-dialog
            :title="dialogTitle"
            :visible.sync="addVis"
            center
            :append-to-body="true"
            :lock-scroll="false"
            class="add-form"
            width="30%"
        >
            <el-form
                :model="addForm"
                ref="addForm"
                label-width="100px"
                :label-position="labelPosition"
                :rules="rules"
            >
                <el-form-item label="设备厂家：">
                    <el-input v-model="addForm.equipvender" placeholder="请输入设备厂家" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="设备名称：">
                    <el-input v-model="addForm.equipName" placeholder="请输入设备名称" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="型号规格：">
                    <el-input v-model="addForm.specifications" placeholder="请输入型号规格" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="安装单位：">
                    <el-input v-model="addForm.installationUnit" placeholder="请输入安装单位" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="检测单位：">
                    <el-input v-model="addForm.testingUnit" placeholder="请输入检测单位" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="检测编号及单位：">
                    <el-input v-model="addForm.testReportNumber" placeholder="请输入检测编号及单位" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="检测日期：">
                    <el-date-picker
                        v-model="addForm.detectionDate"
                        align="right"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="检测有效期：">
                    <el-input v-model="addForm.detectionValidityDate" placeholder="请输入检测有效期" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="备注：">
                    <el-input v-model="addForm.remarks" placeholder="备注" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
            <el-button @click="addVis = false">取 消</el-button>
            <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
            </div>
        </el-dialog> -->
    </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
import base from '../../../untils/base'
export default {
    data(){
        return{
            detectionType:'',
            tableDataEnd:[],
            currentPage:1,
            pageSize:10,
            totalItems:0,
            groupId:'',
            dataText:'数据加载中...',
            types:[
                {id:'0',name:'其他',value:'0'},
                {id:'1',name:'未处理',value:'1'},
                {id:'2',name:'已处理',value:'2'},
            ],
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.getData()
    },
    methods:{
        //查询
        doFilter(){
            this.currentPage = 1
            this.getData()
        },
        getData(){
            var that = this
            myHttp.selectDistributionMaintenancePage({
                detectionType:this.detectionType,
                projectId:this.groupId,
                pageNum:this.currentPage,
                pageSize:this.pageSize
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.pageInfo.list||[]
                    for(var i=0;i<list.length;i++){
                        list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
                    }
                    that.tableDataEnd = list
                    that.totalItems = resp.data.data.pageInfo.total
                    if (that.tableDataEnd.length == 0) {
                        that.dataText = '暂无数据'
                    }
                }else{
                    that.dataText = '暂无数据'
                }
            })
        },
        handleSizeChange(val) {
          this.pageSize = val
          this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val) {
          console.log(`当前页: ${val}`)
          this.currentPage = val
          this.getData()
        },
        // 监控当前页码
        currentChangePage() {
          this.getData()
        },
        

        
    },
}
</script>

<style scoped>
    .main{
        flex-wrap: wrap;
        align-content: flex-start;
    }
    .main-table{
        width: 100%;
        height: calc( 100% - 11.4vh );
    }
    .build-bar {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 6vh;
        border-bottom: 3px solid #17b2fe;
        background: #fff;
        padding: 0 1vw;
    }

    .build-bar span {
        margin-left: 30px;
        white-space: nowrap;
        display: inline-block;
    }

    .build-bar > .el-input {
        width: 200px;
        font-size: 12px;
    }
    .build-bar > .el-button {
        margin-left: 30px;
        /* background-color: #17b2fe;
        border-color: #17b2fe; */
    }
    .erCode{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
        flex-wrap: wrap;
    }
.avatar{
    width: 100%;
}
</style>

<style>
    @import '../../../assets/css/common.css'
</style>